import { render, staticRenderFns } from "./PosDetail.vue?vue&type=template&id=6005684a&"
import script from "./PosDetail.vue?vue&type=script&lang=js&"
export * from "./PosDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports